import {
  EditFilled,
  EyeFilled,
  StopOutlined,
  UnlockOutlined,
} from '@ant-design/icons';
import styled from 'styled-components';
import { Button, Tooltip } from 'antd';

import { Tag } from '../../components/antd/Tag';
import { UsersGroup, UserStatusType } from '../../types';

const GroupsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;
type GroupsRendererProps = {
  groups: Array<UsersGroup>;
  record: any;
  selectUser: (user: any) => void;
};

export function GroupsRenderer(props: GroupsRendererProps) {
  return (
    <GroupsWrapper>
      <div>
        {props.groups.map((permission, index) => {
          return <Tag key={`permission_${index}`}>{permission.name}</Tag>;
        })}
      </div>
      <div style={{ cursor: 'pointer', padding: '5px' }}>
        {props.record.status !== 'BLOCKED' ? (
          <Tooltip title="Editar usuário">
            <Button
              type="text"
              icon={<EditFilled />}
              onClick={() => props.selectUser(props.record)}
              style={{ float: 'right' }}
            />
          </Tooltip>
        ) : (
          <Tooltip title="Visualizar usuário">
            <Button
              type="text"
              icon={<EyeFilled />}
              onClick={() => props.selectUser(props.record)}
              style={{ float: 'right' }}
            />
          </Tooltip>
        )}
      </div>
    </GroupsWrapper>
  );
}
